import {Component} from "@angular/core";

@Component({
    selector: "fui-page-side-panel",
    styleUrls: ["./page-side-panel.component.scss"],
    templateUrl: "./page-side-panel.component.html",
    standalone: false
})
export class FUIPageSidePanelComponent {
    constructor() {
    }
}
